import React, { useContext, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useScreenSize } from '../ScreenSize';

import { AnchorContext } from './Provider';

import styles from './NavAnchor.module.scss';

export * from './Provider';

interface IContent {
  title: string;
  anchor: string;
}

interface IProps {
  content: IContent[];
}

function usePrevious(data: any) {
  const ref = useRef<boolean>(false);
  useEffect(() => {
    setTimeout(() => {
      ref.current = data;
    }, 100);
  }, [data]);
  return ref.current;
}

function NavAnchor(props: IProps) {
  const { content } = props;
  const { size } = useScreenSize();
  const wrapperRef = useRef<HTMLDivElement>(null);

  const { defaultAnchor = '', anchor = '', setAnchor } = useContext(AnchorContext);

  const anchorInvalid = content.map((item) => item.anchor).indexOf(anchor) < 0;

  const currAnchor = anchorInvalid ? defaultAnchor : anchor;

  const prevAnchor = usePrevious(currAnchor);

  useEffect(() => {
    // 初始化的逻辑跳过
    if (size.width === 0) return;
    if (size.width > 768) return;
    if (currAnchor === 's1' && !prevAnchor) return;
    const wrapper = wrapperRef.current;
    const $li = wrapper?.querySelector(`.${styles.itemActive}`) as HTMLDivElement;
    // @ts-ignore
    wrapper?.scroll({ left: ($li?.offsetLeft || 20) - 20, behavior: 'smooth' });
  }, [size, currAnchor]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container} ref={wrapperRef}>
        <ul className={styles.list}>
          {(content || []).map((item) => {
            const isActive = item.anchor === currAnchor;
            return (
              <li key={item.anchor} className={classnames({ [styles.itemActive]: isActive }, styles.item)}>
                <a
                  className={styles.anchor}
                  // href={`#${item.anchor}`}
                  onClick={() => {
                    setAnchor(item.anchor);
                  }}
                >
                  {item.title}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default NavAnchor;
